import { A11yDropdownItemProps } from '../../types/a11y.types'
import { FC, ReactNode } from 'react'
import Link from 'next/link'

interface LinkOrActionWrapperProps {
  a11yProps?: A11yDropdownItemProps
  children: ReactNode
  item: { link?: string; disabled?: boolean; action?: () => void }
}

export const LinkOrActionWrapper: FC<LinkOrActionWrapperProps> = ({
  item,
  children,
  a11yProps,
  ...rest
}) => {
  if (item.disabled) return <>{children}</>
  if (item.link)
    return (
      <Link href={item.link} {...rest} passHref legacyBehavior>
        <a {...a11yProps} style={{ width: '100%' }}>
          {children}
        </a>
      </Link>
    )
  else if (item.action)
    return (
      <a {...a11yProps} onClick={() => item.action?.()} style={{ display: 'flex', width: '100%' }}>
        {children}
      </a>
    )
  else return <></>
}
